import { Outlet } from 'react-router-dom'
import { ScrollToTop } from '@valiant/ui-shared'

export function RootLayout() {
  return (
    <>
      <ScrollToTop />
      <Outlet />
    </>
  )
}
